import React, { Component } from 'react';
import Redirection from './Redirection';
import Textarea from './Textarea';
import Button from './Button';
import Media from './Media';
import File from './File';
import Video from './Video';
import Post from './Post';
import Product from './Product';

import './App.css';

class App extends Component {

  constructor(){
    super();
    this.state = {
      isLoadedResults: false,
      isLoadedKeywords: false,
      isLoadedInitClicked: false,
      isOpenDropDown: false,
      clicked: new Map(),
      results: {},
    }
    
    this.renderSentence = this.renderSentence.bind( this );
    this.handleOnClickSentence = this.handleOnClickSentence.bind( this );
    this.handleOnClickDropdown = this.handleOnClickDropdown.bind( this );
    this.isRenderResult = this.isRenderResult.bind( this );
    this.getResults = this.getResults.bind( this );
    
    this.keywords2Delete = [];
    this.keywordPattern = /\[(.*?)\]/g;
    this.keywordPatternReplace = /\[|\]/g
    this.ajaxResults = null;
    this.ajaxKeywords = null;
    this.apiRoot = window.wpApiSettings.root;
    this.template = window.wpApiSettings.template;
    this.id_sentence = window.wpApiSettings.id_sentence;
    this.primary_sentence = window.wpApiSettings.primary_sentence;
    this.nlf_rewriting_enable = window.wpApiSettings.nlf_rewriting_enable;
    this.nlf_root_url = window.wpApiSettings.nlf_root_url;
    this.nlf_params_url = window.wpApiSettings.nlf_params_url;
    this.allResultsDB = null;
    this.allResults = null;
    this.allKeywords = null;
    this.keywordsLoaded = [];
    this.resultKeywords = '';
    this.isLoadedRenderResult = false;
    this.resultsCache = {};
  }
  componentDidMount() {
    this.getAllResults();
    this.getAllKeywords();
    this.initDirectRenderResult();
  }
  getAllKeywords() {
    if( this.ajaxKeywords !== null ){
      this.ajaxKeywords.abort();
      this.ajaxKeywords = null;
    }
    this.ajaxKeywords = window.jQuery.ajax({
        url: window.wpApiSettings.root + `wpnlf/v1/keywords`,
        dataType: 'json',
        method: 'GET',
        beforeSend: function ( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', window.wpApiSettings.nonce );
        },
        success: function(data) {
          this.allKeywords = data;
          this.setState( { isLoadedKeywords: true } );
        }.bind(this)
    });
  }
  getAllResults(){
    if( this.ajaxResults !== null ){
      this.ajaxResults.abort();
      this.ajaxResults = null;
    }
    this.ajaxResults = window.jQuery.ajax({
      url: this.apiRoot + `wpnlf/v1/results/${this.id_sentence}`,
      dataType: 'json',
      method: 'GET',
      beforeSend: function ( xhr ) {
          xhr.setRequestHeader( 'X-WP-Nonce', window.wpApiSettings.nonce );
      },
      success: function(data) {
        this.allResultsDB = data.resultsDB;
        this.allResults = data.resultsFormated;
        this.setState( { isLoadedResults: true } );
      }.bind(this)
    });
  }
  getResults(){
    const post_data = {
        key: 'keywords',
        value: this.resultKeywords
    };
    window.jQuery.ajax({
        url: window.wpApiSettings.root + `wpnlf/v1/result`,
        dataType: 'json',
        method: 'POST',
        beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', window.wpApiSettings.nonce );
        },
        data: JSON.stringify( post_data ),
        success: function(data) {
            this.isLoadedRenderResult = true;
            this.resultsCache[this.resultKeywords] = data;
            this.setState( { results: this.resultsCache } );
        }.bind(this)
    });
  }
  loadKeyword( i, keyword ){
    if( false === this.keywordsLoaded.includes(keyword) ){
      this.keywordsLoaded.push(keyword);
    }
    let sentences = JSON.parse( this.allKeywords[keyword] );
    // si le keyword est cliqué alors on affiche uniquement le choix
    if( this.state.clicked.has(keyword) ){
      return (
        <div key={i} className="nlf-text-options-selected">
          {sentences.map((sentence, index) => {
            if( this.isInResults( keyword, sentence.id ) ){
              return <span key={index} data-keyword={keyword} data-id={sentence.id} onClick={this.handleOnClickSentence}>{this.renderSentence(sentence.label, keyword)}</span>
            }
            return ''
          })}
        </div>
      );
    }
    // sinon on affiche la liste des choix
    if( "dropdown" === this.template ){
      var dropdownClasses = 'nlf-dropdown';
      if( this.state.isOpenDropDown ){
        dropdownClasses += ' nlf-dropdown-open';
      }
      return (
        <div key={i} className={dropdownClasses}>
          <div className="nlf-dropdown-toggle">
            <div className="nlf-dropdown-text" onClick={this.handleOnClickDropdown}>&nbsp;</div>
            <i className="nlf-dropdown-icon"></i>
          </div>
          <div className="nlf-text-options">
            <ul className="nlf-options">
              {sentences.map((sentence, index) => {
                if( this.isInResults( keyword, sentence.id ) ){
                  return <li key={index} className="nlf-option"><span data-keyword={keyword} data-id={sentence.id} onClick={this.handleOnClickSentence}>{this.renderSentence(sentence.label, keyword)}</span></li>
                }
                return ''
              })}
            </ul>
          </div>
        </div>
      );
    }else{
      return (
        <div key={i} className="nlf-text-options">
          <ul className="nlf-options">
            {sentences.map((sentence, index) => {
              if( this.isInResults( keyword, sentence.id ) ){
                return <li key={index} className="nlf-option"><span data-keyword={keyword} data-id={sentence.id} onClick={this.handleOnClickSentence}>{this.renderSentence(sentence.label, keyword)}</span></li>
              }
              return ''
            })}
          </ul>
        </div>
      );
    }
  }
  handleOnClickDropdown( event ){
    event.preventDefault();
    event.stopPropagation();
    let newIsOpenDropdown = (this.state.isOpenDropDown) ? false : true;
    this.setState({isOpenDropDown: newIsOpenDropdown});
  }
  handleOnClickSentence( event ){
    event.preventDefault();
    event.stopPropagation();
    let newClicked = this.state.clicked;
    if( this.state.clicked.has(event.currentTarget.dataset.keyword) ){
      // Gestion du retour en arrière dans les choix
      const keywordDeleted = event.currentTarget.dataset.keyword;
      this.keywords2Delete = [];
      let find = false;
      this.keywordsLoaded.forEach(element => {
        if( element === keywordDeleted){
          find = true;
        }
        if( find ){
          this.keywords2Delete.push(element);
        }
      });
      newClicked.forEach(this.mapElementsForDelete, this);
    }else{
      newClicked.set( event.currentTarget.dataset.keyword, parseInt(event.currentTarget.dataset.id, 10) );
    }
    this.handleWindowHistory();
    this.setState({clicked: newClicked});
  }
  handleWindowHistory(){
    console.log(this.nlf_rewriting_enable);
    if( "0" !== this.nlf_rewriting_enable ){
      console.log("coucou");
      let currentUrl = this.nlf_root_url;
      if( this.state.clicked.size > 0 ){
        currentUrl += 'nlf/';
      }
      for( var [keyword, id] of this.state.clicked ){
        currentUrl += keyword+"-"+id+"/";
      }
      window.history.replaceState(null, "", currentUrl);
    }
  }
  renderSentence( sentence, keyword = null ){
    let newSentence = '';
    // On coupe la phrase jusqu'au 1er keyword non cliqué
    // 1 - si la phrase contient un/des keywords
    if ( this.hasKeyword(sentence) ){
      // on fait le rendu des keywords uniquement si @keyword est null ou si keyword est cliqué
      if( null === keyword || this.state.clicked.has(keyword) ){
        // on regarde combien de keyword de la phrase sont cliqués
        const total = this.totalClickedSentence( sentence );
        const nextIndexOfKeyword = this.nthIndexOf( sentence, ']', total+1);
        newSentence = sentence.substring( 0, (-1 === nextIndexOfKeyword) ? sentence.length : nextIndexOfKeyword+1);
      }else{ // Sinon on n'affiche pas le keyword
        const nextIndexOfKeyword = this.nthIndexOf( sentence, '[', 1) - 1;
        newSentence = sentence.substring( 0,  nextIndexOfKeyword);
      }
    }else{
      // 2 - si la phrase ne contient pas de keyword
      newSentence = sentence;
    }
    // Remplace les keywords par les listes de propositions
    const reactStringReplace = require('react-string-replace');
    newSentence = reactStringReplace(newSentence, this.keywordPattern, (match, i) => (
      this.loadKeyword( i, match )
    ));
    return newSentence;
  }
  isInResults( keyword, id ){
    // si le keyword est cliqué alors on n'affiche que la phrase cliquée
    if( this.state.clicked.has(keyword) && this.state.clicked.get(keyword) !== id ){
      return false;
    }
    // On n'affiche la phrase que si l'id est dans les resultats
    //const i = this.keywordsLoaded.findIndex( function(element){ return element === keyword } );
    //if( 0 === i){ // cas particulier du 1er keyword
    //  return this.allResults.hasOwnProperty(keyword+id);
    //}else{
      const array = this.getArrayResults(keyword, this.allResults);
      return array[keyword].hasOwnProperty(id);
    //}
  }
  getArrayResults( searchKeyword, searchArray ){
    if( searchArray.hasOwnProperty(searchKeyword) ){
      return searchArray;
    }else{
      for( const key in searchArray ){
        // On recherche uniquement dans les valeurs cliquées
        // Cas particulier pour le 1er element du tableau de resultats
        /*if( -1 !== key.indexOf( this.keywordsLoaded[0] ) ){
          // Si La valeur de key <>  de la valeur cliquée du keyword alors on passe
          if( key === (this.keywordsLoaded[0]+""+this.state.clicked.get(this.keywordsLoaded[0]) ) ){
            // On peux chercher dans cette valeur
            return this.getArrayResults(searchKeyword, searchArray[key]);
          }
        }else{*/
          if( searchArray[key].hasOwnProperty( this.state.clicked.get(key) ) ){
            return this.getArrayResults(searchKeyword, searchArray[key][this.state.clicked.get(key)]);
          }
        //}
      }
    }
  }
  totalClickedSentence( sentence ){
    let n=0;
    // Retourne le nombre de keyword de la phrase présent dans this.clicked
    const keywordsList = sentence.match(this.keywordPattern);
    keywordsList.forEach(element => {
      element = element.replace(this.keywordPatternReplace,'');
      if( this.state.clicked.has( element) ){
        n++;
      }
    });
    return n;
  }
  hasKeyword(sentence){
    return -1 === sentence.indexOf('[') ? false : true;
  }
  nthIndexOf(str, pat, n){
    var L= str.length, i= -1;
    while(n-- && i++<L){
        i= str.indexOf(pat, i);
        if (i < 0) break;
    }
    return i;
  }
  mapElementsForDelete(value, key, map){
    if( this.keywords2Delete.includes( key ) ) {
      map.delete(key);
    }
  }
  isRenderResult(){
    const {clicked} = this.state;
    let result = [];
    clicked.forEach( function(value, key) {
      result.push(key+"###"+value);
    });
    const resultString = result.join('@!@');
    for( var key in this.allResultsDB){
      if( this.allResultsDB[key]['keywords'] === resultString ){
        this.resultKeywords = resultString;
        return true
      }
    }
    return false;
  }
  renderResult(){
    var css = 'nlf-viewer-results nlf-sideDecoration';
    let block = '';
    if( "custom" === this.resultsCache[this.resultKeywords].result_action ){
      block = this.resultsCache[this.resultKeywords].result_value.map((result, index) => {
        if( "textarea" === result.type ){
          return <Textarea key={index} text={result.value} />;
        }
        if( "button" === result.type ){
          return <Button key={index} data={result.value} />;
        }
        if( "image" === result.type ){
          return <Media key={index} data={result.value} />;
        }
        if( "file" === result.type ){
          return <File key={index} data={result.value} />;
        }
        if( "video" === result.type ){
          return <Video key={index} data={result.value} />;
        }
        if( "post" === result.type ){
          return <Post key={index} data={result.value} />;
        }
        if( "product" === result.type ){
          return <Product key={index} data={result.value} />;
        }
        return '';
      })
    }else if( "redirection" === this.resultsCache[this.resultKeywords].result_action ){
      block = <Redirection data={this.resultsCache[this.resultKeywords].result_value} />;
      if ( false === this.resultsCache[this.resultKeywords].result_settings.showResultTitle ){
          css = 'nlf-viewer-results';
      }
    }
    return (
      <div className={css}>
        {this.resultsCache[this.resultKeywords].result_settings.showResultTitle && <h4>{this.resultsCache[this.resultKeywords].result_settings.resultTitleLabel}</h4>}
        {block}
      </div>
    )
  }
  initDirectRenderResult(){
    if (  "" !== this.nlf_params_url ){
      let keywords = this.nlf_params_url.split('/');
      let newClicked = this.state.clicked;
      for( var value in keywords ){
        let values = keywords[value].split('-');
        let keyword = values[0];
        let id = values[1];
        newClicked.set( keyword, parseInt(id, 10) );
      }
      this.nlf_params_url = "";
      this.setState({clicked: newClicked, isLoadedInitClicked: true});
    }else{
      this.setState({isLoadedInitClicked: true});
    }
  }
  saveStats(){
    let resultKeywords = this.resultKeywords.split('@!@');
    for( var value in resultKeywords ){
      let values = resultKeywords[value].split('###');
      let keyword = values[0];
      let id = parseInt(values[1],10);
      let label = '';
      let listKeywordsValues = JSON.parse( this.allKeywords[keyword] );
      for( var i in listKeywordsValues ){
        if( id === listKeywordsValues[i].id ){
          label = listKeywordsValues[i].label;
          break;
        }
      }
      resultKeywords[value] = keyword + '###' + label;
    }
    const post_data = {
        sentence_value: this.primary_sentence,
        sentence_text: document.getElementsByClassName("nlf-render-sentence")[0].innerText,
        keywords: resultKeywords.join('@!@')
    };
    
    window.jQuery.ajax( {
        url: window.wpApiSettings.root + `wpnlf/v1/stats`,
        dataType: 'json',
        method: 'POST',
        beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', window.wpApiSettings.nonce );
        },
        data:JSON.stringify( post_data ),
        error: function( response ){
            //response.code+':'+response.message
        },
        success: function ( response ) {
            //console.log("response", response);
        }
      });
  }
  render() {
    const {isLoadedResults, isLoadedKeywords, isLoadedInitClicked} = this.state;
    if( !isLoadedResults || !isLoadedKeywords || !isLoadedInitClicked ){
      return (
        <div className="natural-langage-form">
          <div>{window.nlfL10n.Loading}</div>
        </div>
      )
    }else{
      //console.log("keywords:", this.allKeywords);
      //console.log("results:", this.allResults);
      //console.log("location:", this.nlf_url);
      let renderResult = '';
      if( this.isRenderResult() ){
        if(!this.isLoadedRenderResult){
          if( !this.resultsCache.hasOwnProperty(this.resultKeywords) ){
            this.getResults();
          }else{
            this.isLoadedRenderResult = true;
            this.setState( { results: this.resultsCache[this.resultKeywords] } );
          }
          renderResult = <div>{window.nlfL10n.Loading}</div>
        }else{
          this.saveStats();
          renderResult = this.renderResult()
        }
      }else{
        this.isLoadedRenderResult = false;
      }
      return (
        <div className="natural-langage-form-viewer">
          <div className="nlf-render-sentence">
            {this.renderSentence( this.primary_sentence )}
          </div>
          {renderResult}
        </div>
      );
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js